import T from './T';
import withT from './withT';

export { withT, T };
export default T;
